module.exports = __webpack_public_path__ + "04_medium_grey.fb7e9806.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/04_medium_grey.png
// module id = IHM4
// module chunks = 0